var components;
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.inited)?_c('v-uni-view',{ref:"u-transition",staticClass:"u-transition",class:_vm.classes,style:([_vm.mergeStyle]),on:{"touchmove":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.noop).apply(void 0, arguments)
},"click":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.clickHandler).apply(void 0, arguments)
}}},[_vm._t("default")],2):_vm._e()}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }